export default __webpack_public_path__ + "static/media/testimon1.8a74c324.mp4";